import { type Href } from 'expo-router';
import { type ReactNode } from 'react';
import { Pressable } from 'react-native';

import { Linkable } from '@/components/ui/Linkable';
import { Text } from '@/components/ui/Text';

/** A single row inside {@link AccountMenu}. Private to the account menu. */
export function MenuItem({
  label,
  href,
  onPress,
  right,
  danger,
}: {
  label: string;
  /** Navigation target — renders a real `<a href>` on web. `onPress` still runs
   *  (e.g. to close the popover) since the Link composes both handlers. */
  href?: Href;
  onPress?: () => void;
  right?: ReactNode;
  danger?: boolean;
}) {
  return (
    <Linkable href={href}>
      <Pressable
        onPress={onPress}
        className="flex-row items-center justify-between rounded-lg px-2 py-2.5 active:bg-well"
      >
        <Text variant="bodyMedium" className={danger ? 'text-alert' : undefined}>
          {label}
        </Text>
        {right}
      </Pressable>
    </Linkable>
  );
}
